import { render, staticRenderFns } from "./BackNav.vue?vue&type=template&id=54ec1670&scoped=true&"
import script from "./BackNav.vue?vue&type=script&lang=ts&"
export * from "./BackNav.vue?vue&type=script&lang=ts&"
import style0 from "./BackNav.vue?vue&type=style&index=0&id=54ec1670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ec1670",
  null
  
)

export default component.exports